<app-banner-card
  [header]="
    adminMode() ? ('pages.admin.adminCampaigns.banner.title' | translate) : ('pages.campaigns.banner.title' | translate)
  "
  [headerHeight]="44"
  [addButtonConfiguration]="addButtonConfiguration()"
  [breadcrumbs]="breadcrumbs"
>
  <div class="mt-16">
    <app-campaigns-kpi-cards />
  </div>
</app-banner-card>
